import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const CarouselComponent = () => (
  <div className='m-auto' id='carousel'>
    <Carousel
      autoFocus
      interval={5000}
      thumbWidth={50}
      infiniteLoop
      useKeyboardArrows
      autoPlay
      showThumbs={false}
      showStatus={false}
      showIndicators={true}
    >
      <div className='w-1/2 m-auto'>
        <img
          src='images/banners/JPLogo.svg'
          aria-label='Jupiter Prime Banner'
          title='Jupiter Prime'
          alt='Jupiter Prime' />
      </div>
      <div className='th'>
        <img
          src='images/banners/banner-capybara.png'
          aria-label='Capybara Banner'
          title='The Jupiter Prime Capybara Range'
          alt='The Jupiter Prime Capybara Range' />
      </div>
      <div>
        <img
          src='images/banners/banner-christmas-voucher.png'
          aria-label='Happy Holidays Voucher Banner'
          title='Enter HAPPYHOLIDAYS at checkout for 15% off!'
          alt='Enter HAPPYHOLIDAYS at checkout for 15% off!' />
      </div>
    </Carousel>
  </div>
);

export default CarouselComponent;
